import { axiosInstance } from "../axios/axiosConfig";
import { ENTERPRISE_API } from "../constants/api-constants";

export const getUserEnterprises = async () => {
  try {
    const response = await axiosInstance.get(ENTERPRISE_API.GET_USER_ENTERPRISES);
    return response?.data || [];
  } catch (error) {
    console.error(ENTERPRISE_API.GET_USER_ENTERPRISES_ERROR, error);
    return [];
  }
};

